var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "w-100 h-100 d-flex flex-column align-items-center justify-content-end position-relative",
      attrs: { id: "remoteUploadDialog" },
    },
    [
      _vm.mode !== "remote_url"
        ? _c(
            "div",
            { staticClass: "position-absolute top-0 left-0 pt-2 pl-3" },
            [
              _c(
                "RouterLink",
                {
                  staticClass:
                    "btn text-white font-size-125 d-inline-flex align-items-center",
                  attrs: {
                    id: "backToUploadButton",
                    to: { name: "file-upload" },
                    tag: "button",
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-arrow-left font-size-200 mr-1",
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm._f("trans")("Back")))]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "font-size-150 font-weight-bold py-3 mb-2" }, [
        _c("i", { staticClass: "fa fa-link" }),
        _vm._v(" " + _vm._s(_vm._f("trans")("Enter URL"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "font-size-125 w-100 px-5 text-center" }, [
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.remoteUrl,
                expression: "remoteUrl",
                modifiers: { trim: true },
              },
            ],
            staticClass: "w-100 rounded no-border py-2 px-3 font-size-125",
            attrs: {
              id: "remoteUrlInput",
              type: "text",
              placeholder: "http://www.example.com/examplefile.pdf",
              onfocus: "this.placeholder=''",
              onblur:
                "this.placeholder='http://www.example.com/examplefile.pdf'",
            },
            domProps: { value: _vm.remoteUrl },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.addRemoteUrl.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.remoteUrl = $event.target.value.trim()
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "btn-success btn font-weight-bold text-uppercase mt-4 py-2 vue-uploadbox-remote-add-button",
            attrs: { id: "addRemoteUrlButton" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.addRemoteUrl.apply(null, arguments)
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-plus" }),
            _vm._v(" " + _vm._s(_vm._f("trans")("Add")) + "\n        "),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "font-size-125 py-3 text-center" }, [
          _c(
            "a",
            {
              staticClass: "text-white px-2 cursor-pointer",
              attrs: {
                title: _vm._f("trans")(
                  "Specify a downloader that fits your task"
                ),
                href: "javascript:void(0)",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.openSettingsModal.apply(null, arguments)
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-cog" }),
              _vm._v(
                " " + _vm._s(_vm._f("trans")("Settings")) + "\n            "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }